import React from "react";
import styles from "./ModalUploadContent.module.css";
import SimpleModalContent, {SimpleModalType} from "./SimpleModalContent";
import {useCsContext} from "../../state/CsInstance";

interface ModalUploadType extends SimpleModalType {
	text?: string;
	onSuccess: (file?: File) => void;
}

export default function ModalUploadContent(props: ModalUploadType) {
	const options = {...props.options};
	const csInstance = useCsContext();
	if (!options?.submitText) {
		options.submitText = "Upload";
	}

	const [files, setFiles] = React.useState<FileList | undefined>();
	const [doUpload, setDoUpload] = React.useState(false);

	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		const newFiles = event.target.files;
		if (newFiles !== null) {
			setFiles(newFiles);
		}
	}

	const onClickSuccess = async () => {
		props.onSuccess(files?.[0]);

		if (!files || !files.length) return;

		const yamls = await Promise.all(
			[...files].sort((a, b) => (a.name < b.name ? -1 : 1)).map((f) => f.text())
		);

		if (doUpload) csInstance.codeStore.setServerSideYamls(yamls);

		csInstance.codeStore.resetProject();
		csInstance.codeStore.compileCode();
	};

	return (
		<SimpleModalContent {...{...props, onSuccess: onClickSuccess, options}}>
			{props.text}
			<div className={styles.uploadContainer}>
				<input
					className={styles.uploadInput}
					type="file"
					onChange={handleChange}
					multiple={true}
				/>
			</div>
			<div>
				<input
					id={"doUpload"}
					type={"checkbox"}
					onChange={(value) => {
						setDoUpload(value.target.checked);
					}}
				/>
				<label htmlFor={"doupload"}>Upload to server?</label>
			</div>
		</SimpleModalContent>
	);
}
